import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../constants";
import { FaSpinner, FaLock, FaUserCircle } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "../modules/login/Login.css";
import nestlogo from "../assets/APPROVED_NEST TYPO DARK.svg";

const ResetPassword = () => {
  // return false
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);
  const location = useLocation(); // To access the URL params
  const navigate = useNavigate(); // For redirecting after password reset

  // Get the token and email from the URL
  const queryParams = new URLSearchParams(location.search);
  const token = location.pathname.split("/")[2]; // Extract the token from the URL path
  const email = queryParams.get("email"); // Extract the email from the URL query string

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation for empty fields
    if (password !== passwordConfirmation) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }

    setSubmitted(true);
    try {
      // Send the token, email, and new password to the backend to reset the password
      const response = await axios.post(`${API_URL}password/reset`, {
        email,
        token,
        password,
        password_confirmation: passwordConfirmation,
      });

      // If the password reset is successful
      if (response.status === 200) {
        toast.success("Password has been reset successfully.");
        setTimeout(() => {
          // Redirect user to the login page or home page after successful reset
          navigate("/login"); // Adjust as per your application's login page route
        }, 2000);
      }
      setSubmitted(false);
    } catch (err) {
      // Handle errors from the backend
      if (
        err?.response &&
        err?.response?.data &&
        err?.response?.data?.message
      ) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Failed to reset password. Please try again later.");
      }
      setSubmitted(false);
    }
  };
  return (
    <>
      <div className="nest-login-page">
        <div className="container">
          <div className="text-center logo-mobile-only">
            <img src={nestlogo} className="logoImgLogin" alt="Logo" />
          </div>
          <div class="row">
            <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
              <div class="login-container">
                <FaLock className="lock-icon"></FaLock>
                <br />
                <strong class="card-title">Reset Your Password</strong>
                <form class="login-form" onSubmit={handleSubmit}>
                  <p className="mb-1">Please Enter Your New Password</p>
                  <div className="login-form-group">
                    <span className="fa fa-user-circle form-control-icon login-input-icon"></span>
                    <input
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                      className={
                        error.email
                          ? "form-control login-form-control invalid"
                          : "form-control login-form-control"
                      }
                      id="password"
                      name="password"
                      placeholder="Password"
                      style={{
                        backgroundColor: "transparent",
                        color: "#66c4de",
                        WebkitTextFillColor: "#66c4de",
                        transition: "background-color 5000s ease-in-out 0s",
                        paddingRight: "45px", // Add space for eye icon
                      }}
                    />
                    <span
                      className="fa fa-eye-slash form-control-icon password-toggle-icon"
                      onClick={(e) => {
                        const input = e.target
                          .closest(".login-form-group")
                          .querySelector("input");
                        input.type =
                          input.type === "password" ? "text" : "password";
                        e.target.classList.toggle("fa-eye-slash");
                        e.target.classList.toggle("fa-eye");
                      }}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "15px",
                        // top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: "10",
                        fontSize: "16px",
                        color: "#66c4de",
                      }}
                    ></span>
                  </div>

                  {/* Confirm Password */}
                  <div className="login-form-group">
                    <span className="fa fa-user-circle form-control-icon login-input-icon"></span>
                    <input
                      type="password"
                      onChange={(e) => setPasswordConfirmation(e.target.value)}
                      className={
                        error.email
                          ? "form-control login-form-control invalid"
                          : "form-control login-form-control"
                      }
                      id="password_confirmation"
                      value={passwordConfirmation}
                      name="password_confirmation"
                      placeholder="Confirm Password"
                      style={{
                        backgroundColor: "transparent",
                        color: "#66c4de",
                        WebkitTextFillColor: "#66c4de",
                        transition: "background-color 5000s ease-in-out 0s",
                        paddingRight: "45px", // Add space for eye icon
                      }}
                    />
                    <span
                      className="fa fa-eye-slash form-control-icon password-toggle-icon"
                      onClick={(e) => {
                        const input = e.target
                          .closest(".login-form-group")
                          .querySelector("input");
                        input.type =
                          input.type === "password" ? "text" : "password";
                        e.target.classList.toggle("fa-eye-slash");
                        e.target.classList.toggle("fa-eye");
                      }}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "15px",
                        // top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: "10",
                        fontSize: "16px",
                        color: "#66c4de",
                      }}
                    ></span>
                  </div>
                  <div className="text-center">
                    <button
                      disabled={submitted ? true : false}
                      type="submit"
                      // className="login-custom"
                      style={{
                        width: "70%",
                        padding: "10px",
                        borderRadius: "30px",
                        background: "#2BB2FF",
                        color: "white",
                        border: "none",
                        fontWeight: "bold",
                        marginTop: "20px",
                      }}
                    >
                      {submitted ? (
                        <FaSpinner class="sm-spinner" />
                      ) : (
                        "RESET PASSWORD"
                      )}
                    </button>
                  </div>
                </form>
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </div>
            </div>
            {/* <div class="col-sm-6"></div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
